import React from 'react';

import './globalstyles.css';
import { Header, MobileMenuContainer } from './style/headerStyles';
import MobileMenu from './pages/MobileMenu';
import DesktopMenu from './pages/DesktopMenu';

const App = () => (
  <div className="menus">
    <Header>
      <MobileMenuContainer>
        <MobileMenu />
      </MobileMenuContainer>
      <DesktopMenu />
    </Header>
  </div>
);

export default App;
